import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import StatusTable from './components/StatusTable';
import Loader from 'loaders/Loader';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';

const Status = () => {
  // const [statusData, setRolesData] = useState([]);
  // const [loading, setLoading] = useState(true);

  // const fetchStatus = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await createAPIEndPoint('clinic_status').fetchAll();
  //     setRolesData(response.data.roles || []);
  //   } catch (err) {
  //     toast.error(err?.response?.data?.error || 'Error fetching statuses    ');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchStatus();
  // }, []);
  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {/* {loading && <Loader />} */}
      <StatusTable />{' '}
    </Box>
  );
};

export default Status;
